module.exports = {
	"name": "case-law-app-js",
	"version": "0.5.0",
	"private": true,
	"homepage": "https://nlesc.github.io/case-law-app",
	"devDependencies": {
		"enzyme": "=2.7.1",
		"gh-pages": "=0.12.0",
		"react-addons-test-utils": "=15.4.2",
		"react-dom": "15.4.2",
		"react-scripts": "0.7.0"
	},
	"dependencies": {
		"babyparse": "^0.4.6",
		"colormap": "2.2.0",
		"rc-slider": "^8.1.5",
		"react": "15.4.2",
		"react-dom": "15.4.2",
		"react-mdl": "^1.11.0",
		"react-select": "^1.0.0-rc.5",
		"react-sigma": "=1.2.17",
		"react-simple-file-input": "1.0.0"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"deploy": "npm run build&&gh-pages -d build"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 447
 ** module chunks = 0
 **/